import React, { useState, useEffect } from "react";
import { signIn, getCurrentUser,signInWithRedirect } from "@aws-amplify/auth";
import { Link, useNavigate } from "react-router-dom";
import toastr from "toastr";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Layout from "../layout/Layout";
import "toastr/build/toastr.min.css";



const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          navigate("/pricing");
        }
      } catch {}
    };

    checkUser();
  }, [navigate]);
  useEffect(() => {
    document.title = "Login | HRMA";
  }, []);
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toastr.error("Username and password are required");
      return;
    }
  
    setLoading(true);
  
    try {
      const { user } = await signIn({ username, password });
      toastr.success("Login successful!");
      const formData = new FormData();
      formData.append("email", username);  
      formData.append("password", password);
      const response = await fetch(`${process.env.REACT_APP_CHECK_USER_API}/api/auth/login`, {
        method: "POST",
        body: formData, 
      });
      if (response.ok) {
        const data = await response.json();
        
        localStorage.setItem("user", JSON.stringify(data.user));

        navigate("/dashboard");
      } else {
        const errorData = await response.json();
        toastr.error(errorData.message || "Login failed.");
      }
    } catch (error) {
      toastr.error(error.message || "Something went wrong during sign-in.");
    } finally {
      setLoading(false); // Reset loading state
    }
  };
  

  return (
    <Layout title={"Login HRMA"}>
      <div className="container-fluid">
        <div className="row w-100 h-100">
          {/* Left Section */}
          <div className="col-lg-8 left-section">
            <div className="text-center">
              <img
                src="/images/login.png"
                alt="3D Illustration"
                className="img-fluid"
                style={{ maxWidth: "60%" }}
              />
            </div>
          </div>

          {/* Right Section */}
          <div className="col-lg-4 right-section">
            <div className="form">
              <h3>Welcome 👋</h3>
              <p>Please sign in to your account and start the adventure</p>
              <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <input
                    type="text"
                    id="username"
                    className="form-control"
                    placeholder="Email"
                    // autoComplete="off"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <div className="input-group">
                    <input
                      type={passwordVisible ? "text" : "password"}
                      id="password"
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={togglePasswordVisibility}
                    >
                      {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                <div className="RememberMe d-flex justify-content-between align-items-center mb-3">
                <div>
                  <input
                    type="checkbox"
                    id="rememberMe"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="custom-checkbox"
                  />
                  <label htmlFor="rememberMe" className="ms-2">
                    Remember Me
                  </label>
                </div>

                  <Link to="/forgot-password" className="forgetPassword">
                    Forgot Password?
                  </Link>
                </div>

                <button
                  type="submit"
                  className="btn btn-Login-Signup w-100"
                  disabled={loading}
                >
                  {loading ? "Please Wait..." : "LOGIN"}
                </button>
              </form>

              <p className="mt-4 text-center">
                New on our platform?{" "}
                <Link to="/register" className="primary-text">
                  Create an account
                </Link>
              </p>

            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LoginPage;